<template>
  <ApplicationLayout>
    <v-container
      fluid
      px-12
      py-6
    >
      <div
        class="
          d-flex
          pb-6
          align-center
        "
      >
        <h2
          class="display-1"
        >Tags</h2>

        <v-spacer></v-spacer>

        <TableSearch
          label="Search tags"
          v-model="search"
          @input="doSearch"
        ></TableSearch>

        <NewButton
          to-name="new-tag"
          class="ml-6"
        >Create new tag</NewButton>
      </div>

      <v-data-table
        :headers="headers"
        :items="tags"
        :page="page"
        :items-per-page="itemsPerPage"
        :sort-by.sync="sortBy"
        @update:sort-by="updatePagination"
        :sort-desc.sync="sortDesc"
        @update:sort-desc="updatePagination"
        multi-sort
        hide-default-footer
        :loading="loading"
        @page-count="pageCount = $event"
        @click:row="goToTag"
      >
        <template v-slot:item.updated_at="{ item }">
          <span
            class="text-no-wrap"
            :id="`focus_${item.id}`"
          >
            {{ new Date(item.updated_at).toLocaleDateString() }}
          </span>
        </template>

        <template v-slot:item.created_at="{ item }">
          <span class="text-no-wrap">
            {{ new Date(item.created_at).toLocaleDateString() }}
          </span>
        </template>
      </v-data-table>

      <div
        class="py-6"
      >
        <TablePagination
          v-model="page"
          @input="updatePagination"
          :itemsPerPage.sync="itemsPerPage"
          @update:itemsPerPage="updatePagination"
          :pageCount.sync="pageCount"
          :total="tags.length"
        ></TablePagination>
      </div>
    </v-container>
  </ApplicationLayout>
</template>

<script>
import { mapState } from 'vuex'
import ApplicationLayout from '../components/layouts/ApplicationLayout.vue'
import TableSearch from '../components/TableSearch.vue'
import NewButton from '../components/NewButton.vue'
import TablePagination from '../components/TablePagination.vue'

export default {
  components: {
    ApplicationLayout,
    TableSearch,
    NewButton,
    TablePagination
  },
  data() {
    const { itemsPerPage, sortBy, sortDesc, search } = this.$pagination.getOptions('tags')
    return {
      search,
      pageCount: 0,
      page: 1,
      loading: true,
      itemsPerPage,
      sortBy,
      sortDesc,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Last update', value: 'updated_at' },
        { text: 'Creation date', value: 'created_at' }
      ]
    }
  },
  computed: {
    ...mapState('Tags', ['tags'])
  },
  async created() {
    await this.$store.dispatch('Tags/getAll', { search: this.search })
    const { page } = this.$pagination.getOptions('tags')
    this.page = page
    this.$pagination.focus()
    this.updatePagination()
    this.loading = false
  },
  methods: {
    updatePagination() {
      this.$pagination.update({
        itemsPerPage: this.itemsPerPage,
        page: this.page,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        search: this.search
      }, 'tags')
    },
    goToTag(tag) {
      this.$router.push({
        name: 'tag',
        params: { id: tag.id }
      })
    },
    async doSearch() {
      this.page = 1
      this.loading = true
      await this.$store.dispatch('Tags/getAll', { search: this.search })
      this.loading = false
      this.updatePagination()
    }
  }
}
</script>
